<template>
  <div class="add">
    <BackHome title="组织入驻" />
    <div class="content">
      <div class="item">
        <div class="left"><span class="star">*</span>组织名称：</div>
        <a-input
          v-model="params.orgname"
          placeholder="请输入组织名称"
          :maxLength="20"
          class="input-common"
          style="width: 440px"
        />
      </div>
      <div class="item">
        <div class="left"><span class="star">*</span>登记状态：</div>
        <a-select
          placeholder="请选择"
          @change="chooseStatus"
          class="input-common"
          style="width: 440px"
        >
          <a-select-option
            v-for="(item, index) in orgStatusList"
            :key="index"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <div class="extra" @click="showAlert">说明</div>
      </div>
      <div class="item">
        <div class="left"><span class="star">*</span>组织类型：</div>
        <a-select
          placeholder="请选择"
          @change="chooseTypes"
          class="input-common"
          style="width: 440px"
        >
          <a-select-option
            v-for="(item, index) in typeOptions"
            :key="index"
            :value="item._id"
          >
            {{ item.shortName }}
          </a-select-option>
        </a-select>
        <div class="extra" @click="showAlert">说明</div>
      </div>
      <div class="item">
        <div class="left"><span class="star">*</span>组织地址：</div>
        <div class="address">
          <a-select
            placeholder="请选择"
            @change="chooseProvince"
            class="input-common"
            style="width: 133px; margin-right: 20px"
          >
            <a-select-option
              v-for="(item, index) in provinceData"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a-select
            placeholder="请选择"
            :value="params.cityId"
            @change="chooseCity"
            class="input-common"
            style="width: 133px; margin-right: 20px"
          >
            <a-select-option
              v-for="(item, index) in cityData"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
          <a-select
            placeholder="请选择"
            :value="params.countyId"
            @change="chooseCounty"
            class="input-common"
            style="width: 133px"
          >
            <a-select-option
              v-for="(item, index) in countyData"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="item">
        <div class="left"><span class="star">*</span>联系邮箱：</div>
        <a-input
          v-model="params.email"
          placeholder="请输入组织邮箱"
          :maxLength="20"
          class="input-common"
          style="width: 440px"
        />
      </div>
      <div class="item">
        <div class="left"><span class="star">*</span>联系人姓名：</div>
        <a-input
          v-model="params.realname"
          placeholder="请输入联系人真实姓名"
          :maxLength="20"
          class="input-common"
          style="width: 440px"
        />
      </div>
      <div class="item">
        <div class="left"><span class="star">*</span>联系人身份证号：</div>
        <a-input
          v-model="params.idcard"
          placeholder="请输入联系人身份证号"
          :maxLength="18"
          class="input-common"
          style="width: 440px"
        />
      </div>
      <div class="item">
        <div class="left"><span class="star">*</span>联系人手机：</div>
        <a-input
          v-model="params.phone"
          placeholder="联系人手机号"
          :maxLength="20"
          class="input-common"
          style="width: 440px"
        />
      </div>

      <div class="item">
        <div class="left"><span class="star">*</span>组织申请函：</div>
        <div class="upload_box">
          <div class="upload_btn">
            <input
              class="input_upload"
              type="file"
              accept="image/*"
              @change="uploadWithSDK"
            />
            <span class="upload_tips">{{ uploadImg ? "已上传" : "上传" }}</span>
          </div>
          <a
            class="download-text"
            href="./template.docx"
            download="组织入驻申请模板.docx"
            >申请函模板查看</a
          >
        </div>
      </div>
      <div class="item" style="align-items: baseline">
        <div class="left"><span class="star">*</span>组织介绍：</div>
        <a-textarea
          placeholder="请输入组织介绍，不少于50个字"
          :rows="4"
          class="input-common"
          style="width: 440px; height: auto"
          v-model="params.description"
        />
      </div>
      <div class="item" style="align-items: baseline">
        <div class="left"><span class="star">*</span>组织申请原因：</div>
        <a-textarea
          placeholder="请输入申请原因，不少于15个字"
          :rows="4"
          class="input-common"
          style="width: 440px; height: auto"
          v-model="params.reason"
        />
      </div>

      <div class="bottom">
        <a-checkbox @change="onChange" class="left">提交代表您同意</a-checkbox>
        <div class="right" @click="toAgree">《志愿晋中用户协议》</div>
      </div>

      <div class="button submit" @click="submit">提交</div>
    </div>

    <a-modal v-model="visible" title="说明" :footer="null" width="613px">
      <p class="modal-tips">
        1.如贵公司组织在当地民政部门登记注册，有民政部门办法的登记证书（如基
        金会、社会服务机构、社会团体）、登记状态选择民政部门登记注册、组织类型
        根据登记证书类型选择（民办非企业单位可选择社会服务机构）。
      </p>
      <p class="modal-tips">
        2.其余组织登记状态选择未在民政部门登记注册，组织类型根据实际情况选
        择。例：XX县市场监督局志愿服务队，选择党政机关内部成立；XX镇平安志愿服
        务队，选择乡镇街道备案；XX村志愿服务队，选择基层群众性自治组织（居委会
        或村委会）；XX大学青年志愿者协会，选择高校内部成立；XX小学红领巾服务队，选择中小学等其他学校内部成立（该类型组织若在公司所在乡镇街道盖章挂靠，也请选择民营等其他企业内部成立）；社会自组织就是指自发成立、自主发展、自行动作、具有一定规模的，以民间组织形式存在，逐步从无序走向有序的社会组织。以上类型均不符合的组织选择其他公益组织。
      </p>
    </a-modal>
  </div>
</template>

<script>
import BackHome from "@/components/common/BackHome.vue";
import { isIdentityId, isTel, isEmail } from "@/utils/validate";
import * as qiniu from "qiniu-js";

export default {
  components: {
    BackHome,
  },
  data() {
    return {
      params: {
        orgname: "",
        orgStatus: "",
        type: "",
        provinceId: "",
        cityId: undefined,
        countyId: undefined,
        email: "",
        realname: "",
        idcard: "",
        phone: "",
        description: "",
        reason: "",
      },

      orgStatusList: [
        { value: 0, name: "未在民政部门登记" },
        { value: 1, name: "民政部门登记" },
      ],
      visible: false,
      typeOptions: [],
      provinceData: [],
      cityData: [],
      countyData: [],

      uploadImg: "",
      uploadRes: {},
      checked: false,
      loading: false,
    };
  },
  created() {
    // this.$EventBus.$emit('showMenu', false);
  },
  mounted() {
    // 获取类型、省市区信息
    this.getTypes();
    this.getAreas();
    this.getUploadToken();
  },
  methods: {
    submit() {
      if (this.loading) return;
      if (!this.params.orgname) {
        this.$message.error("请输入组织名");
        return;
      }
      if (this.params.orgStatus === "") {
        this.$message.error("请选择登记状态");
        return;
      }
      if (!this.params.type) {
        this.$message.error("请选择组织类型");
        return;
      }
      if (
        !this.params.provinceId ||
        !this.params.cityId ||
        !this.params.countyId
      ) {
        this.$message.error("请选择完整的组织地址");
        return;
      }
      if (!isEmail(this.params.email)) {
        this.$message.error("请输入正确的联系邮箱");
        return;
      }
      if (!this.params.realname) {
        this.$message.error("请输入联系人真实姓名");
        return;
      }
      if (isIdentityId(this.params.idcard)) {
        this.$message.error("请输入有效的联系人身份证号");
        return;
      }
      if (!isTel(this.params.phone)) {
        this.$message.error("请输入有效的手机号码");
        return;
      }
      if (!this.uploadImg) {
        this.$message.error("请上传组织申请函");
        return;
      }
      if (!this.params.description || this.params.description.length < 50) {
        this.$message.error("请输入不少于50字的组织介绍");
        return;
      }
      if (!this.params.reason || this.params.reason.length < 15) {
        this.$message.error("请输入不少于15字的申请原因");
        return;
      }
      if (!this.checked) {
        this.$message.error("请查看并同意该协议");
        return;
      }

      const parmas = {
        deptname: this.params.orgname,
        registerstatus: this.params.orgStatus,
        depttype: this.params.type,
        applyuser: this.params.realname,
        idcard: this.params.idcard,
        mobile: this.params.phone,
        email: this.params.email,
        province: this.params.provinceId,
        city: this.params.cityId,
        county: this.params.countyId,
        remark: this.params.description,
        reason: this.params.reason,
        applyLetterUrl: this.uploadImg,
      };

      this.loading = true;
      this.$api.vmsapi
        .orgApplay(parmas)
        .then((res) => {
          if (res.status || res.message.indexOf("组织入驻申请成功") > -1) {
            this.$success({
              title: "提交成功",
              content:
                "组织入驻申请成功，入驻申请正在审核中，审核周期为1-3个工作日，如有疑问请直接联系客服：400-003-5125。",
              closable: true,
              okText: "确定",
              onCancel: () => {
                this.goHome();
              },
              onOk: () => {
                this.goHome();
              },
            });
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goHome() {
      this.$router.replace({name: 'home'});
    },

    // 登记状态选择
    chooseStatus(value) {
      this.params.orgStatus = value;
    },
    // 组织类型选择
    chooseTypes(value) {
      this.params.type = value;
    },
    // 说明
    showAlert() {
      this.visible = true;
    },
    toAgree() {
      console.log("agree");
    },
    onChange() {
      this.checked = !this.checked;
    },

    // 获取组织类型
    getTypes() {
      this.$api.vmsapi.getDict("depttype").then((res) => {
        this.typeOptions = res;
      });
    },
    chooseProvince(value) {
      this.params.provinceId = value;
      this.params.cityId = undefined;
      this.params.countyId = undefined;
      this.getAreas(1, value);
    },
    chooseCity(value) {
      this.params.cityId = value;
      this.params.countyId = undefined;
      this.getAreas(2, value);
    },
    chooseCounty(value) {
      this.params.countyId = value;
    },
    // 获取省市区
    getAreas(level = 0, id = "14737477846505d6208a5e781435b84e2e079304353cb") {
      this.$api.vmsapi.getArea(id).then((res) => {
        if (level === 0) {
          this.provinceData = res;
          this.params.cityId = undefined;
          this.params.countyId = undefined;
        } else if (level === 1) {
          this.cityData = res;
          this.params.countyId = undefined;
        } else {
          this.countyData = res;
        }
      });
    },

    // 获取token
    getUploadToken() {
      this.$api.xsdapi.getUploadToken().then((res) => {
        this.uploadRes = res;
      });
    },
    // 上传图片
    next(value) {
      console.log(value);
    },
    error(value) {
      console.log(value);
    },
    complete(value) {
      this.uploadImg = this.uploadRes.url + value.key;
    },
    uploadWithSDK(e) {
      const putExtra = {
        fname: "",
        params: {},
        mimeType: ["image/jpeg", "image/png", "image/jpg"],
      };
      const config = {
        useCdnDomain: true,
        disableStatisticsReport: false,
        retryCount: 6,
        region: qiniu.region.z0,
      };
      const _this = this;
      const file = e.srcElement.files[0];
      if (file) {
        if (file.size > 10485760) {
          this.$message.error("文件大小超过10M");
          return;
        }
        if (
          putExtra.mimeType.findIndex(function (val) {
            return val == file.type;
          }) == -1
        ) {
          this.$message.error("文件类型暂不支持");
          return;
        }

        var subObject = {
          next: _this.next,
          error: _this.error,
          complete: _this.complete,
        };
        // 调用sdk上传接口获得相应的observable，控制上传和暂停
        const observable = qiniu.upload(
          file,
          _this.uploadRes.key,
          _this.uploadRes.token,
          putExtra,
          config
        );
        // const subscription = observable.subscribe(subObject);
        observable.subscribe(subObject);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add {
  width: 770px;
  margin: 0 auto;
  margin-bottom: 100px;
  .content {
    background-color: #ffffff;
    padding: 50px 50px 60px;

    .item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .left {
        width: 120px;
        font-size: 14px;
        font-family: Helvetica;
        color: #333333;
        text-align: left;
        white-space: nowrap;
        .star {
          color: #ff0000;
          margin-right: 5px;
        }
      }
      .input-common {
        font-size: 14px;
        font-family: Helvetica;
        height: 36px;
      }

      .extra {
        font-size: 14px;
        font-family: Helvetica;
        color: #cd3232;
        margin-left: 10px;
        cursor: pointer;
      }

      .upload_box {
        display: flex;
        align-items: center;
        .upload_btn {
          position: relative;
          flex: 0 1 100px;
          width: 100px;
          height: 36px;
          border: 1px solid #cd3232;
          font-size: 14px;
          color: #cd3232;
          .input_upload {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 3;
            cursor: pointer;
            opacity: 0;
          }
          .upload_tips {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            display: inline-block;
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 36px;
            border-radius: 2px;
          }
        }

        .download-text {
          flex: none;
          padding-left: 10px;
          line-height: 36px;
          font-size: 14px;
          color: #cd3232;
          cursor: pointer;
        }
        .download-text:hover {
          font-weight: 600;
        }
      }
    }

    .button {
      margin-left: 120px;
      width: 439px;
      height: 36px;
      border-radius: 2px;
      margin-bottom: 20px;
      cursor: pointer;

      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Helvetica;
    }
    .submit {
      background: #cd3232;
      color: #ffffff;
    }

    .bottom {
      margin-left: 120px;
      margin-bottom: 39px;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      .left {
        color: #727384;
      }
      .right {
        color: #cd3232;
        cursor: pointer;
      }
    }
  }
}
.modal-tips {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}
</style>